import { config, opened, toggleOpen } from '../../store/widget-store';
import { useI18n } from '../../hooks/use-i18n';
import { useBubbleDrag } from '../../hooks/use-bubble-drag';
import { DragHint } from '../DragHint';
import { IconMessageCircle } from './icons';

/**
 * 网页客服悬浮气泡 — 仅 cfg.type === 'web' 时由 App.tsx 渲染。
 * 视觉照搬 cankao/wangyezujian CustomerServiceWidget 的「未展开」分支:
 * 渐变蓝圆形 + MessageCircle + 蓝色水波涟漪扩散(双层环,引导点击)。
 * 点击展开面板;长按可拖动调整位置。
 */
export function WebBubble() {
  const cfg = config.value;
  const isOpen = opened.value;
  const { t } = useI18n();
  const { dragging, style, onClick, pointerHandlers } = useBubbleDrag(toggleOpen);

  if (!cfg || !cfg.showButton || isOpen) return null;

  const ariaLabel = t('bubble.open');

  return (
    <button
      type="button"
      class={`dcs-web-bubble${dragging ? ' dragging' : ''}`}
      aria-label={ariaLabel}
      title={ariaLabel}
      style={style}
      onClick={onClick}
      {...pointerHandlers}
    >
      <span class="dcs-web-bubble-ripple" aria-hidden="true" />
      <span class="dcs-web-bubble-ripple dcs-web-bubble-ripple--2" aria-hidden="true" />
      <IconMessageCircle size={32} class="dcs-web-bubble-icon" />
      <DragHint dragging={dragging} />
    </button>
  );
}
